import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';

export const messages = { 'zh-CN': zhCN, en };

export const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'en',
  messages,
});

export function setLocale(locale: string) {
  i18n.global.locale.value = locale as keyof typeof messages;
  localStorage.setItem('app-locale', locale);
}

export function initLocale() {
  const saved = localStorage.getItem('app-locale');
  if (saved && messages[saved as keyof typeof messages]) {
    i18n.global.locale.value = saved as keyof typeof messages;
  }
}
